export default __webpack_public_path__ + "static/media/debate_21.f887070d.JPG";